import React from "react";
import {
  useParams
} from "react-router-dom";

import MiddleLayout from '../layouts/MiddleLayout'
import Feedbacks from "../components/Feedbacks";

const PublicFeedbacks = () => {
  const { id } = useParams();

  return (
    <MiddleLayout bgImage dark>
      <div className='w-96'>
        <Feedbacks id={id} fullOpacity/>
      </div>
    </MiddleLayout>
  );
}

export default PublicFeedbacks
